module.exports = __webpack_public_path__ + "static/img/m_name.0abb23a.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/zxrx/m_name.png
// module id = FAFI
// module chunks = 7